module.exports = __webpack_public_path__ + "img/150.7424662d.jpg";